/**
 * ReminderOffset — pure helpers for CalEvent reminder offset strings.
 * Format: <number><unit> where unit is m (minutes), h (hours) or d (days).
 * Matches the -r flag in the CalEvent DSL spec.
 */

export const REMINDER_PRESETS = [
    { label: '5 minuten',  value: '5m' },
    { label: '15 minuten', value: '15m' },
    { label: '30 minuten', value: '30m' },
    { label: '1 uur',      value: '1h' },
    { label: '2 uur',      value: '2h' },
    { label: '1 dag',      value: '1d' },
    { label: 'Custom...',  value: '__custom__' },
];

const OFFSET_PATTERN = /^\d+[mhd]$/;

/**
 * Returns true if value is a valid reminder offset string (e.g. "30m", "2h", "1d").
 * @param {string} value
 * @returns {boolean}
 */
export const isValidOffset = (value) => OFFSET_PATTERN.test(value);

/**
 * Returns true if value is not one of the known presets — i.e. a custom offset.
 * @param {string} value
 * @returns {boolean}
 */
export const isCustomOffset = (value) => {
    return !REMINDER_PRESETS.slice(0, -1).some((p) => p.value === value);
};

const UNIT_MS = {
    m: 60 * 1000,
    h: 60 * 60 * 1000,
    d: 24 * 60 * 60 * 1000,
};

/**
 * Converts a reminder offset string (e.g. "30m", "2h", "1d") to milliseconds.
 * Returns 0 for invalid or empty input.
 * @param {string} value
 * @returns {number}
 */
export const offsetToMs = (value) => {
    if (!value || !isValidOffset(value)) return 0;

    const unit = value.slice(-1);
    const amount = parseInt(value.slice(0, -1), 10);

    return amount * (UNIT_MS[unit] ?? 0);
};
